export default {
  resource:{
    zh: {
      title:"人事变动",
      companyNo: "公司",
      companyName: "公司",
      rq1: "开始日期",
      rq2: "结束日期",
      empNo: "工号",
      empId: "工号",
      empName: "姓名",
      idCardNo:	"身份证号",
      status:	"状态",
      target:"项目",
      tfrom:"变动前",
      tto:"变动后",
      effNow:	"立即生效",
      status1:	"未生效",
      status2:	"已生效",
      effDate:	"生效日期",
      createBy:	"经办",
      createDate:	"建单日期",
      updateBy:	"最后更改人",
      updateDate:	"更改日期",
      remark:	"变动原因",
      duty:	"职务",
      xgroup:	"组别",
      dept:	"部门",
      jobTitle:	"职称",
      job:	"岗位",
      nullId:"工号不能为空！",
      notFound: "找不到记录，请检查！",
      nullXm: "请先输入正确的工号！",
      nullXmt: "请先输入变动后的姓名！",
      nullBm: "请先输入正确的部门！",
      nullZw: "请先输入正确的职位！",
      nullGw: "请先输入正确的岗位！",
      nullZc: "请先输入正确的职称！",
      nullEffDate:"请先输入生效日期！"
    }
  },
  delConf:["empName"],
  delKeys:["autoid"],
  buttons:[
    {key:"View", noRights:"true", class:"add_view", singelCheck: true},
    {key:"Copy", rights:"Add", class:"add_copy", singelCheck: true},
    {key:"Add", class:"add_add"},
    {key:"Edit", class:"add_edit", singelCheck: true},
    {key:"Delete", class:"add_delete", singelCheck: true}
  ],
  params: {
    companyNo:{
      key: "companyNo",
      defaultIdx: 0,
      method: "Contains",
      type: "select",
      options:"company"
    },
    rq1:{
      key: "effDate",
      tkey: "rq1",
      data: null,
      method: "GreaterThanOrEqual",
      type: "date"
    },
    rq2:{
      key: "effDate",
      tkey: "rq2",
      data: null,
      method: "LessThanOrEqual",
      type: "date"
    },
    bh:{
      key: "empId",
      data: null,
      method: "Equal",
      type: "text"
    },
    xm:{
      key: "empName",
      data: null,
      method: "Contains",
      type: "text"
    }
  },
  listDefine: [ "companyName",
    "empId","empName",{key:"effDate", formatter: "fdate", width: 120},
    {key:"target", formatter: "tf", width: 140}, {key:"status", formatter:"sf"},"createBy",
    {key:"createDate", formatter: "fdate"},"updateBy",{key:"updateDate", formatter: "fdate"},"remark"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName:"effDate",
  defaultSortOrder:"desc",
  sortName: "effDate",
  sortOrder: "desc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "hrChange/",
  autoId: "autoid",
  dept: null,
  formatter: {
    tf(t, cl, item, rs) {
      const arr = t.split(",")
      let i, tmp
      for(i=0; i< arr.length; i++){
        tmp = arr[i]
        if (tmp == "empName") arr[i]=rs["empName"]
        else if (tmp == "dept") arr[i] = rs["deptNo"]
        else if (tmp == "duty") arr[i] = rs["duty"]
        else if (tmp == "job") arr[i] = rs["job"]
        else if (tmp == "jobTitle") arr[i] = rs["jobTitle"]
      }
      return arr.join(",")
    },
    sf(t){
      return "status" + t
    },
    showEdit(cl, item){
      if (item.status == 2) return false 
      return true
    }
  },
  customActionState: {
    Edit:function(selIdx, config) {
      if(typeof selIdx !== "number" ) return false 
      const row = config.list[selIdx]
      return row.status==1
    },
    Delete:function(selIdx, config) {
      return config.customActionState.Edit(selIdx, config)
    }
  }

}
